import React, { Component } from "react";
import config from "../../baseConfig";

class Tab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: props.index || 0,
    };

    this.componentIsMounted = true;
  }

  componentDidMount() {
    if (this.props.hasOwnProperty("history")) {
      this.props.history.listen((location, action) => {
        if (this.componentIsMounted) {
          let path = location.pathname.split("/"),
            pathSecondParam = path[path.length - 1];

          if (pathSecondParam === "forgot-password-b2c") {
            this.setState({ activeItem: 0 });
          } else if (pathSecondParam === "forgot-password-b2b") {
            this.setState({ activeItem: 1 });
          }
        }
      });
    }
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.changeTab) {
      nextState.activeItem = nextProps.index;
    }

    return nextState;
  }

  render() {
    if (!this.props.items.length) {
      return "";
    }

    const items = this.props.items.map((item, index) => {
      return (
        <li className="tab__item ver-top-box" key={index}>
          <button
            className={`tab__link fs14 db${
              index === this.state.activeItem ? " tab__link--active" : ""
            }`}
            type="button"
            onClick={() => {
              this.setState({ activeItem: index });

              if (item.hasOwnProperty("changeUrlTo")) {
                this.props.history.push(config.urlPrefix + item.changeUrlTo);
              }

              if (item.hasOwnProperty("clickCallback")) {
                item.clickCallback();
              }
            }}
          >
            {item.title}
          </button>
        </li>
      );
    });

    return (
      <>
        <ul className={`tab${this.props.className || ""} tc`}>{items}</ul>
        {this.props.items[this.state.activeItem]["content"]}
      </>
    );
  }
}

export default Tab;
